import Games from '@/apps/Games'
import Layout from '@/apps/layout/components'
import React from 'react'

const GamesPage = (): React.ReactElement => {
  return (
    <Layout>
      <Games />
    </Layout>
  )
}

export default GamesPage
